<template>
  <div class="setTask">
    <div class='wrapHeader'>
      <el-form :inline="true" :model="selectTask" class="demo-form-inline">
        <el-form-item label="任务名称" prop='taskName'>
          <el-input v-model="selectTask.taskName" @change="selectList"></el-input>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="selectTask.timeType" clearable placeholder="任务类型" @change="selectList">
            <el-option :label="item.taskName" :value="item.taskCode" v-for='item in taskType' :key='item.taskCode'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='publicWrap'>
        <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
          <el-button type="primary" icon="el-icon-plus" class="commonBtn addTask" plain @click="addTask">添加任务</el-button>
          <el-button type="primary" icon="el-icon-video-play" class="commonBtn startTask" plain @click="allStart">全部启动</el-button>
          <el-button type="danger" icon="el-icon-video-pause" class="commonBtn stopTask" plain @click="allStop">全部停止</el-button>
          <div class='setMacView' :style="`height:${height-100}px;width:${width-60}px`">
            <el-table
              :data="taskData"
              style="width: 100%"
              :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'
              :max-height="height-149"
              border
            >
              <el-table-column type="index" width="60" align='center' label="序号" :index="indexMethod"></el-table-column>
              <el-table-column prop="taskName" label="方案名称" align="center" min-width='100'></el-table-column>
              <el-table-column
                prop="timeType"
                label="任务类型"
                align="center"
                min-width='100'
              >
                <template slot-scope="scope">
                  <span>{{scope.row.timeType==0?"每周":(scope.row.timeType==1?'每天':'指定时间')}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="time"
                :label="setTaskType==0?'采集时间':'检测时间'"
                align="center"
                min-width='100'
                v-if='setTaskType==0||setTaskType==1'
              >
              </el-table-column>
              <el-table-column
                v-else
                label='执行时间'
                align='center'
                min-width='200'>
                <template slot-scope="scope">
                  <span>
                    <span v-if="scope.row.timeType==0">
                      <dict-tag style="display:inline-block" :options='weekList' :value='scope.row.week'/>
                    </span>
                    {{scope.row.timeSlot}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                label="任务状态"
                align="center"
                min-width='80'
              >
                <template slot-scope="scope">
                  <span :class='scope.row.status==0?"onLine":"offLine"'>{{scope.row.status==0?"启动":"停止"}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="updateTime"
                label="制定时间"
                align="center"
                min-width='150'
              >
              </el-table-column>
              <el-table-column 
                label="操作" 
                min-width="200" 
                fixed='right'
                align='center'>
                <template slot-scope="scope">
                  <el-button @click.native.prevent="startTask(scope.row.taskId,scope.row.jobId,scope.row.status)" type="text" size="small">{{scope.row.status==1?'启动任务':'停止任务'}}</el-button>
                  <el-button @click.native.prevent="editTask(scope.row.taskId)" type="text" size="small">修改任务</el-button>
                  <el-button @click.native.prevent="delTask(scope.row.taskId)" type="text" size="small">删除任务</el-button>
                  <el-button @click.native.prevent="taskDetail(scope.row.taskId)" type="text" size="small">日志详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="total"
              :hide-on-single-page='true'
              :pageSize='selectTask.pageSize'
              :current-page='selectTask.pageNum'
              @current-change='pageChange'
              class='setPosition'>
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="setTaskInfoType" :visible.sync="taskView"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg"'>
      <div class='formWrap'>
        <el-form label-width="110px" ref="taskInfo" :model='taskInfo' :rules='taskRules'>
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>任务基本信息</div>
          <div class='dialog-setWrap'>
            <el-form-item label="任务名称" prop='taskName'>
              <el-input 
                v-model="taskInfo.taskName" 
                @input="changeView">
              </el-input>
            </el-form-item>
            <el-form-item label="仓房选择" prop='wareId' v-if="setTaskType==4">
              <el-select 
                v-model="taskInfo.wareId" 
                placeholder="仓房选择" 
                @change='wareChange'>
                <el-option 
                  :label="item.wareName" 
                  :value="item.wareId" 
                  v-for='item in allWareList' 
                  :key='item.wareId'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务类型" prop='timeType'>
              <el-select 
                v-model="taskInfo.timeType" 
                placeholder="任务类型">
                <el-option
                  :label="item.taskName" 
                  :value="item.taskCode" 
                  v-for='item in taskType' 
                  :key='item.taskCode'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="每周" prop='week' v-if='taskInfo.timeType==0'>
              <el-select v-model="taskInfo.week" placeholder="指定每周时间">
                <el-option 
                  :label="item.label" 
                  :value="item.value" 
                  v-for='item in weekList' 
                  :key='item.value'>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="setTaskType==0?'采集时间':'检测时间'" prop='time' v-if="setTaskType==0||setTaskType==1">
              <el-date-picker
                v-if='taskInfo.timeType==2'
                v-model="taskInfo.time"
                type="datetime"
                @input="changeView"
                format='yyyy-MM-dd HH:mm'
                value-format='yyyy-MM-dd HH:mm'
                placeholder="选择日期时间">
              </el-date-picker>
              <el-time-picker
                v-else
                v-model="taskInfo.time"
                format='HH:mm'
                value-format='HH:mm'
                @input="changeView"
                placeholder="选择采集时间"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59'
                }">
              </el-time-picker>
            </el-form-item>
            <el-form-item label="开始时间" prop='startTime' v-if="setTaskType==2||setTaskType==3||setTaskType==4">
              <el-date-picker
                v-if="taskInfo.timeType==3"
                v-model="taskInfo.startTime"
                type="datetime"
                @input="changeView"
                format='yyyy-MM-dd HH:mm'
                value-format='yyyy-MM-dd HH:mm'
                :picker-options="startPickerOpts"
                placeholder="选择开始日期时间">
              </el-date-picker>
              <el-time-picker
                v-else
                v-model="taskInfo.startTime"
                format='HH:mm'
                @input="changeView"
                value-format='HH:mm'
                placeholder="选择开始时间"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59'
                }">
              </el-time-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop='endTime' v-if="setTaskType==2||setTaskType==3||setTaskType==4">
              <el-date-picker
                v-if="taskInfo.timeType==3"
                v-model="taskInfo.endTime"
                type="datetime"
                @input="changeView"
                format='yyyy-MM-dd HH:mm'
                value-format='yyyy-MM-dd HH:mm'
                :picker-options="endPickerOpts"
                placeholder="选择结束日期时间">
              </el-date-picker>
              <el-time-picker
                v-else
                v-model="taskInfo.endTime"
                format='HH:mm'
                @input="changeView"
                value-format='HH:mm'
                placeholder="选择结束时间"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59'
                }">
              </el-time-picker>
            </el-form-item>
          </div>
          <div class='baseInfoTitle' style="padding-top:10px" v-if="setTaskType==4"><span></span>配置设备</div>
          <div class='baseInfoTitle' style="padding-top:10px" v-else><span></span>配置仓房</div>
          <div class='dialog-setWrap' v-if="setTaskType==4">
            <el-checkbox 
              :indeterminate="isIndeterminate" 
              v-model="checkAll"
              @change="handleCheckAllChange">全选</el-checkbox>
            <el-form-item>
              <el-checkbox-group 
                v-model="serIdList" 
                @change='handleCheckedWareChange' 
                class="taskwareWrap">
                <div 
                  class='commonItem wareItem' 
                  v-for='item in serList' 
                  :key='item.serId'>
                  <el-checkbox :label="item.serId">
                    {{item.serName}}
                    <div class='airImg'></div>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div class='dialog-setWrap' v-else>
            <el-checkbox
              :indeterminate="isIndeterminate" 
              v-model="checkAll"
              @change="handleCheckAllChange">全选</el-checkbox>
            <el-form-item>
              <el-checkbox-group 
                v-model="wareIdList" 
                @change='handleCheckedWareChange' 
                class="taskwareWrap">
                <div 
                  class='commonItem wareItem' 
                  v-for='item in allWareList' 
                  :key='item.wareId'>
                  <el-checkbox :label="item.wareId">{{item.wareName}}
                    <div :class='item.wareType==0?"wareImg":"siloImg"'></div>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveTask('taskInfo')">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="日志详情" :visible.sync="view"
      :close-on-click-modal='false'
      width='1000px !important'
      :custom-class='"dialog-setBg"'>
      <div style="padding-bottom:20px">
        <el-table
          :data="logList"
          style="width: 100%;"
          :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'
          border
          :size='medium'
        >
          <el-table-column type="index" width="60" align='center' label="序号" :index="setIndexMethod"></el-table-column>
          <el-table-column prop="jobName" label="任务名称" align="center" min-width='100'></el-table-column>
          <el-table-column
            prop="jobResult"
            label="执行结果"
            align="center"
            min-width='100'>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="执行时间"
            align="center"
            min-width='100'
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="logTotal"
          :pageSize='selectLog.pageSize'
          :current-page='selectLog.pageNum'
          @current-change='logChange'
          class='pagenation'>
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number,
    setTaskType:String
  },
  data(){
    const ruleTimeSlot=(rule,val,callback)=>{
      if(rule.field=='startTime'){
        if(this.taskInfo.endTime){
          if(this.taskInfo.startTime>=this.taskInfo.endTime){
            callback(new Error("结束时间要大于开始时间"))
          }else{
            this.$refs.taskInfo.clearValidate();
            callback()
          }
        }
      }else if(rule.field=='endTime'){
        if(this.taskInfo.startTime){
          if(this.taskInfo.startTime>=this.taskInfo.endTime){
            callback(new Error("结束时间要大于开始时间"))
          }else{
            this.$refs.taskInfo.clearValidate();
            callback()
          }
        }
      }
    }
    const ruleTime=(rule,val,callback)=>{
      if(this.taskInfo.timeType==2){
        if(Date.parse(new Date())>new Date(this.taskInfo.time).getTime()){
          callback(new Error("设置时间太小"))
        }else{
          callback()
        }
      }else{
        callback()
      }
    }
    return{
      selectTask:{
        taskName:'',
        taskType:this.setTaskType,
        timeType:'',
        pageNum:1,
        pageSize:14,
        orderByColumn:'createTime',
        isAsc:'desc'
      },
      taskData:[],
      total:0,
      taskType:[
        {
          taskCode:'1',
          taskName:'每天'
        },{
          taskCode:'0',
          taskName:'每周'
        },{
          taskCode:this.setTaskType==0||this.setTaskType==1?'2':'3',
          taskName:'指定时间'
        }
      ],
      weekList:[
        {
          value:'1',
          label:'周日'
        },{
          value:'2',
          label:'周一'
        },{
          value:'3',
          label:'周二'
        },{
          value:'4',
          label:'周三'
        },{
          value:'5',
          label:'周四'
        },{
          value:'6',
          label:'周五'
        },{
          value:'7',
          label:'周六'
        }
      ],
      taskView:false,
      taskInfo:{
        timeType:"1",
        week:'1',
        taskType:this.setTaskType,
        startTime:'',
        endTime:''
      },
      setTaskInfoType:'',
      checkAll:false,
      isIndeterminate:false,
      wareList:[],
      allWareList:[],
      wareIdList:[],
      allWareId:[],
      allTotal:0,
      serList:[],
      serIdList:[],
      allSerId:[],
      serTotal:0,
      loading:false,
      taskRules:{
        taskName:[{trigger:'blur',message:'任务名称不能为空',required:true}],
        time:[
          {trigger:'blur',message:'时间不能为空',required:true},
          {trigger:'blur',validator:ruleTime}
        ],
        endTime:[
          {trigger:'blur',message:'时间不能为空',required:true},
          {trigger:'blur',validator:ruleTimeSlot}
        ],
        startTime:[
          {trigger:'blur',message:'时间不能为空',required:true},
          {trigger:'blur',validator:ruleTimeSlot}
        ]
      },
      startPickerOpts:{
        disabledDate:(t)=>{
          return this.taskInfo.endTime?t.getTime()>new Date(this.taskInfo.endTime).getTime():false
        }
      },
      endPickerOpts:{
        disabledDate:(t)=>{
          return this.taskInfo.startTime?t.getTime()<new Date(this.taskInfo.startTime).getTime():false
        }
      },
      logList:[],
      logTotal:0,
      view:false,
      selectLog:{
        pageNum:1,
        pageSize:10
      }
    }
  },
  created(){
    this.getWareList()
  },
  methods:{
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res){
          this.wareList=res.data;
          this.allTotal=res.data.length;
          let arr1=[],arr2=[],arr3=[]
          res.data.forEach(item=>{
            arr3.push(item.wareId)
            if(item.wareType==0){
              arr1.push(item)
            }else{
              arr2.push(item)
            }
          })
          this.allWareList=[...arr1,...arr2];
          this.allWareId=arr3;
          this.getTaskList()
        }
      })
    },
    selectList(){
      this.getTaskList()
    },
    getTaskList(){
      axios.get('/system/timeTask/list',{params:this.selectTask}).then(res=>{
        if(res){
          this.taskData=res.rows;
          this.total=res.total;
        }
      })   
    },
    addTask(){
      this.taskView=true;
      this.isIndeterminate=false;
      this.checkAll=false;
      this.selectTask.taskName='';
      this.selectTask.timeType='';
      if(this.setTaskInfoType){
        this.$refs.taskInfo.resetFields();
        this.wareIdList=[];
        this.serIdList=[]
      }
      this.setTaskInfoType='添加任务';
    },
    allStart(){
      let params={
        taskType:this.setTaskType,
        status:0
      }
      this.allStartTask(params)
    },
    allStop(){
      let params={
        taskType:this.setTaskType,
        status:1
      }
      this.allStartTask(params)
    },
    allStartTask(params){
      axios.post('/system/timeTask/oneStartOrStop',params).then(res=>{
        if(res){
          this.$message({
            type: 'success',
            message: params.status==0?'启动成功':'停止成功',
            duration:1000
          });
          this.getTaskList()
        }
      })
    },
    editTask(taskId){
      this.taskView=true;
      this.setTaskInfoType='修改任务'
      this.taskData.forEach(item=>{
        if(item.taskId==taskId){
          this.$nextTick(() => {
            this.taskInfo=item; 
            if(this.setTaskType==2||this.setTaskType==3||this.setTaskType==4){
              let timeArr=item.timeSlot.split('_');
              this.$set(this.taskInfo, 'startTime', timeArr[0])
              this.$set(this.taskInfo, 'endTime', timeArr[1])
            }
            if(this.setTaskType==4){
              let arr=item.param.split(',').map(Number);
              this.$set(this.taskInfo,'wareId',arr[0]);
              this.getSerList(arr[0],true)
              this.serIdList=arr.filter((item,index)=>index!==0);
            }else{
              this.wareIdList=item.param.split(',').map(Number);
              if(this.wareIdList.length==this.allWareId.length){
                this.isIndeterminate = false
                this.checkAll=true
              }else{
                if(this.wareIdList.length>0){
                  this.isIndeterminate = true
                }
              }
            }
          })
        }
      })
    },
    delTask(taskId){
      this.$confirm('此操作将永久删除该任务, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/system/timeTask/deleteByTaskId/${taskId}`).then(res=>{
          if(res){
            this.getTaskList()
            this.$message({
              type: 'success',
              message: '删除成功!',
              duration:1000
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration:1000
        });          
      });
    },
    startTask(taskId,jobId,status){
      let params={
        taskId:taskId,
        jobId:jobId
      }
      if(status==0){
        params.status=1
      }else{
        params.status=0
      }
      axios.post('/system/timeTask/changeStatus',params).then(res=>{
        if(res){
          this.$message({
            type: 'success',
            message: status==1?'启动成功':'停止成功',
            duration:1000
          });
          this.getTaskList()
        }
      })
    },
    wareChange(val){
      this.getSerList(val)
    },
    getSerList(val,flag){
      axios.get(`/system/air/getAirByWareId/${val}`).then(res=>{
        if(res){
          let data=res.data;
          this.serList=data;
          this.serTotal=data.length;
          this.allSerId=data.map(item=>item.serId);
          if(flag){
            if(this.serIdList.length==this.allSerId.length){
              this.isIndeterminate = false
              this.checkAll=true
            }else{
              if(this.serIdList.length>0){
                this.isIndeterminate = true
              }
            }
          }
        }
      })
    },
    handleCheckAllChange(val){
      if(this.setTaskType==4){
        this.serIdList = val ? this.allSerId : [];
      }else{
        this.wareIdList = val ? this.allWareId : [];
      }
      this.isIndeterminate = false;
    },
    handleCheckedWareChange(value){
      let checkedCount = value.length;
      if(this.setTaskType==4){
        this.checkAll = checkedCount === this.serTotal;
        this.isIndeterminate = checkedCount > 0 && checkedCount <this.serTotal;
      }else{
        this.checkAll = checkedCount === this.allTotal;
        this.isIndeterminate = checkedCount > 0 && checkedCount <this.allTotal;
      }     
    },
    setLoading(){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialog-setBg')
      })
    },
    saveTask(formName){
      this.$refs[formName].validate(valid=>{
        if(valid){
          this.setLoading();
          let params=this.taskInfo;
          if(this.setTaskType==4){
            let arr=[params.wareId,...this.serIdList]
            params.param=arr.toString();
            params.timeSlot=params.startTime+'_'+params.endTime
          }else{
            params.param=this.wareIdList.toString();
            if(this.setTaskType==2||this.setTaskType==3){
              params.timeSlot=params.startTime+'_'+params.endTime
            }
          }
          if(this.setTaskInfoType=='添加任务'){
            axios.post('/system/timeTask',params).then(res=>{
              this.loading.close()
              if(res){
                this.$message({
                  type: 'success',
                  message: '添加成功!',
                  duration:1000
                });
                this.taskView=false;
                this.getTaskList()
              }
            })
          }else{
            axios.put('/system/timeTask',params).then(res=>{
              this.loading.close();
              if(res){
                this.$message({
                  type: 'success',
                  message: '修改成功!',
                  duration:1000
                });
                this.taskView=false;
                this.getTaskList()
              }
            })
          }
        }else{
          return false
        }
      })
    },
    indexMethod(index){
      return (this.selectTask.pageNum-1)*this.selectTask.pageSize+index+1
    },
    pageChange(val){
      this.selectTask.pageNum=val;
      this.selectTask.taskName='';
      this.selectTask.timeType='';
      this.getTaskList()
    },
    changeView(e){
      this.$forceUpdate()
    },
    taskDetail(jobId){
      if(jobId){
        this.selectLog.jobId=jobId;
      }
      axios.get(`/system/timeTaskLog/listByJobId`,{params:this.selectLog}).then(res=>{
        if(res){
          this.logList=res.rows;
          this.logTotal=res.total;
          this.view=true;
        }
      })
    },
    logChange(val){
      this.selectLog.pageNum=val;
      this.taskDetail()
    },
    setIndexMethod(index){
      return (this.selectLog.pageNum-1)*this.selectLog.pageSize+index+1
    },
  }
}
</script>

<style lang="scss" scoped>
.setTask{
  .addTask{
    left: 15px;
  }
  .startTask{
    left: 140px
  }
  .stopTask{
    left: 275px;
  }
  .taskwareWrap{
    width: 690px;
    margin-left: -112px
  }
  .onLine{color: #3BD14A}
  .offLine{color: #AFAFAF}
  .wareItem{
    width: 125px;
    height: 75px;
    margin:10px 10px 3px 3px;
    .wareImg{
      width: 59px;
      height: 41px;
      background-image: url('../../assets/grain/checkWareHouse.png');
      background-size: cover;
      position: absolute;
      bottom: -42px;
      left: 55px;
    }
    .siloImg{
      height: 41px;
      width:33px;
      background-image: url("../../assets/grain/checkSquatSilo.png");
      background-size: cover;
      position: absolute;
      bottom: -42px;
      left: 75px;
    }
    .el-checkbox{
      position: absolute;
      left: 5px;
      top: 5px;
      line-height: 0
    }
    .is-checked .wareImg{
      background-image: url('../../assets/ware/wareHouse.png');
    }
    .is-checked .siloImg{
      background-image: url("../../assets/ware/squatSilo.png");
    }
    .airImg{
      height: 45px;
      width:66px;
      background-image: url("../../assets/air/air.png");
      background-size: cover;
      position: absolute;
      bottom: -45px;
      left: 45px;
    }
  }
  .pagenation{
    text-align: center;
    margin-top: 10px;
  }
}
</style>
